import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SubscriptionDetailsData {
  subscription: any;
}

@Component({
  selector: 'app-subscription-details-dialog',
  templateUrl: './subscription-details-dialog.component.html',
  styleUrls: ['./subscription-details-dialog.component.css']
})
export class SubscriptionDetailsDialogComponent {
  sub: any;

  constructor(
    public dialogRef: MatDialogRef<SubscriptionDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SubscriptionDetailsData
  ) {
    this.sub = data.subscription || {};
  }

  getStatusText(sub: any): string {
    if (sub?.status) return sub.status;
    if (sub?.payment_status === 'Paid' || sub?.payment_status === 1) return 'Active';
    if (sub?.payment_status === 'Pending' || sub?.payment_status === 0) return 'Pending';
    return sub?.statusDetails?.message || '—';
  }

  /** Maps DB numeric/string payment_status to a readable label */
  getPaymentStatusLabel(sub: any): string {
    const ps = sub?.payment_status;
    if (ps === 1 || ps === '1') return 'Paid';
    if (ps === 0 || ps === '0') return 'Pending';
    if (typeof ps === 'string') {
      const s = ps.trim();
      if (s.toLowerCase() === 'paid') return 'Paid';
      if (s.toLowerCase() === 'pending') return 'Pending';
      if (s) return s;
    }
    return '—';
  }

  /** subscriptions.subscription_user_type: free_user | trial_user | paid_user */
  getSubscriptionUserTypeLabel(sub: any): string {
    const t = sub?.subscription_user_type ?? sub?.type;
    if (!t) return 'Not set (legacy)';
    switch (String(t).toLowerCase()) {
      case 'free_user':
        return 'Free (no charge)';
      case 'trial_user':
        return 'Trial';
      case 'paid_user':
        return 'Paid';
      default:
        return String(t);
    }
  }

  getStatusDetails(sub: any): any {
    return sub?.statusDetails || {};
  }

  getStatusClass(sub: any): string {
    const status = this.getStatusText(sub).toLowerCase();
    if (status.includes('active')) return 'is-active';
    if (status.includes('pending')) return 'is-pending';
    if (status.includes('suspend') || status.includes('expired')) return 'is-inactive';
    return 'is-default';
  }

  getPaymentStatusClass(sub: any): string {
    const paymentStatus = this.getPaymentStatusLabel(sub).toLowerCase();
    if (paymentStatus === 'paid') return 'is-active';
    if (paymentStatus === 'pending') return 'is-pending';
    return 'is-default';
  }

  close(): void {
    this.dialogRef.close();
  }

  printInvoice(): void {
    window.print();
  }
}
